import api from './api';

export const financialService = {
  getDashboard: () => api.get('/financial/dashboard').then((r) => r.data),

  getCharts: (period?: string) =>
    api
      .get('/financial/dashboard/charts', { params: period ? { period } : {} })
      .then((r) => r.data),

  getForecast: (months?: number) =>
    api.get('/financial/forecast', { params: months ? { months } : {} }).then((r) => r.data),

  getCustomers: (params?: Record<string, any>) =>
    api.get('/financial/customers', { params }).then((r) => r.data),

  getCustomerDetail: (id: string) => api.get(`/financial/customers/${id}`).then((r) => r.data),

  triggerSync: () => api.post('/financial/sync').then((r) => r.data),

  getSyncStatus: () => api.get('/financial/sync/status').then((r) => r.data),

  getSettings: () => api.get('/financial/settings').then((r) => r.data),

  updateSettings: (settings: {
    enabled: boolean;
    syncIntervalMinutes: number;
    mcpServerCommand: string;
  }) => api.put('/financial/settings', settings).then((r) => r.data),
};
